import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: '[body-template]' })
export class BodyTemplateDirective {
  constructor(public template: TemplateRef<any>) {}
}
